import AcceptingDraftOrderForm  from '../components/accepting_draft_order_form'

export default {
  components: {
    AcceptingDraftOrderForm
  }
}